import { render, staticRenderFns } from "./CourseModal.vue?vue&type=template&id=498d51b5&scoped=true&"
import script from "./CourseModal.ts?vue&type=script&lang=ts&"
export * from "./CourseModal.ts?vue&type=script&lang=ts&"
import style0 from "./CourseModal.vue?vue&type=style&index=0&id=498d51b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498d51b5",
  null
  
)

export default component.exports